module.exports = "<app-homepage></app-homepage>\n"